import React, { useEffect, useState, Fragment } from 'react'
import { Navigate, useNavigate, useLocation, Link } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux';
import store from 'store/store';
import Header from './header/Header';
import Sidebar from './sidebar/Sidebar';
import SidebarV2 from './sidebar/SidebarV2';
import Menu from './sidebar/Menu';
import Footer from './footer/Footer';
import { AxiosUser as Axios } from 'connection/Axios'
import * as IconsBi from "react-icons/bi";
import PropagateLoader from "react-spinners/PropagateLoader";
import { ToastContainer, toast } from 'react-toastify';
import logoIcon from 'assets/images/logo-icon.png'
import { Status, threePoint, dictionary } from 'components/common/Config'

import 'react-toastify/dist/ReactToastify.css';

import { Alert } from 'react-bootstrap';




function Protected(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const state = store.getState()
    const dispatch = useDispatch();

    const [redirectTo, setRedirectTo] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [target, setTarget] = useState(false)
    const [sidebar, setSidebar] = useState(false)
    let [color, setColor] = useState("#ffffff");

    const [re_render, setRe_render] = useState(1);
    const updateStateForReRender = () => {
        setRe_render(re_render + 1)
    }

    useEffect(() => {
        // console.log('Protected - new state:', state.loading)
    }, [dispatch])

    useEffect(() => {
		// console.log('useEffect - navigate:',navigate)
		// console.log('useEffect - sidebar:',sidebar)
        // if(!sidebar)
        //     sidebarToggle()
    }, [navigate])

    useEffect(() => {
        // console.log('Protected - useEffect')
        if (props.user?.token) {
            // return props.children
        } else if (localStorage.getItem('token')) {
            let token = localStorage.getItem('token')
            if(token !== null && token !== undefined) {
                Axios.post('/check-token', JSON.stringify({token: token}))
                .then(async (res) => {
                    // console.log('check-token - res.data:', res.data)
                    let data = res.data
                    let userInfo = {
                        id: data.data.id,
                        name: data.data.name,
                        lastName: data.data.last_name,
                        email: data.data.email,
                        avatar: data.data.avatar,
                        type: data.data.type,
                        token: token
                    }
                    store.dispatch({ type: 'LOGIN', payload: userInfo });
                    // store.dispatch({ type: 'SET_LANG', payload: {lang: localStorage.getItem('lang')} });
                })
                .catch((err) => {
                    console.log('check-token - err:',err)
                    // console.log('check-token - err.response.status:',err.response.status)
                    if(parseInt(err.response.status) === 500)
                        setTarget('/500')
                    else if(parseInt(err.response.status) === 401)
                        setTarget('/login')
                    else
                        setTarget('/404')
                    setHasError(true)
                })
            }
        } else {
            setRedirectTo(true)
        }
    }, [])

    const [collapsed, setCollapsed] = useState(false);

    const sidebarToggle = () => {
        setSidebar(!sidebar)
    }




    const [toggled, setToggled] = useState(false);
    const [broken, setBroken] = useState(window.matchMedia('(max-width: 800px)').matches);

    



    if(hasError)
        return <Navigate to={target} replace />

    if(redirectTo)
        return <Navigate to="/" replace state={props.redirectTo} />
        
    return (
        <>
            {
                <div className={!collapsed ? "wrapper" : "wrapper toggled"} style={{ display: 'flex', height: '100%', minHeight: '400px' }}>
                    {/* <Sidebar sidebarToggle={sidebarToggle} sidebar={sidebar} /> */}
                    <SidebarV2 toggled={toggled} collapsed={collapsed} />
                    

                    <Header sidebar={sidebar} sidebarToggle={sidebarToggle} updateStateForReRender={updateStateForReRender} collapsed={collapsed} setCollapsed={setCollapsed} broken={broken} />

                    {/*
                    <ToastContainer
                        position="top-left"
                        autoClose={10000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={true}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />
                    */}
                    

                    <div className="page-wrapper">
                        <div className="page-content">
                            {
                                React.cloneElement(props.children, {re_render: re_render})
                            }
                        </div>
                    </div>

                    <div className="overlay toggle-icon"></div>

                    <a href="#" className="back-to-top"><i className='bx bxs-up-arrow-alt'></i></a>
                    {/* <Footer /> */}
                </div>
            }
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps)(Protected);